module.exports = __webpack_public_path__ + "static/img/dashboard_logo_left.be767e8.svg";


//////////////////
// WEBPACK FOOTER
// ./static/prism/images/dashboard_logo_left.svg
// module id = 4XiZ
// module chunks = 74